<template>
  <div class="pb-0" style="width: 100%">
    <custom-text-textarea
      v-if="nameInput"
      @contextmenu.prevent="onContextMenu"
      @mouseup="onMouseUp"
      @mousedown="onMouseDown"
      v-model="item.name"
      class="user_input no-margin"
      style="width: 100%"
    ></custom-text-textarea>

    <!--    <v-row dense >-->
    <!--      <v-col cols="12" md="3" v-for="(splitText, index) in splitTexts" :key="`splitTexts${index}`">-->
    <!--        <custom-input-text -->
    <!--            hide-details-->
    <!--            v-model="splitTexts[index]"-->
    <!--            class="user_input no-margin"-->
    <!--        ></custom-input-text>-->
    <!--      </v-col>-->
    <!--      <v-col cols="12" md="3" v-if="splitTexts.length">-->
    <!--        <v-btn color="success" @click="clickDown">-->
    <!--          <v-icon>mdi-restart</v-icon>-->
    <!--        </v-btn>-->
    <!--      </v-col>-->
    <!--    </v-row>-->
    <!--        <v-btn color="primary" @click="split">Split</v-btn>-->
    <context-menu :position="position" v-model="dialog">
      <div class="mb-2">
        <v-btn @click="split" width="100%" color="primary">Split</v-btn>
      </div>
      <div>
        <v-btn @click="remove" width="100%" color="error">Remove</v-btn>
      </div>
    </context-menu>
  </div>
</template>

<script>
import ContextMenu from "@/components/ui/context-menu/ContextMenu";
import "./attribute-separation.scss";

const historyTextType = {
  deleted: "deleted",
  split: "split",
};

class HistoryText {
  constructor(type, text, splitText = null) {
    if (historyTextType[type]) {
      this.type = type;
      this.text = text;
      this.splitText = splitText;
    } else {
      throw new Error("Error history text type " + type);
    }
  }
}

export default {
  name: "AttributeSeparation",
  props: {
    item: {},
    nameInput: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    attributeInputs: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      productId: null,
      constructorDialog: false,
      dialog: false,
      isStartedMoving: false,
      splitTexts: [],
      text: null,
      textData: {
        index: null,
        offset: null,
        splitText: null,
      },
      position: {
        top: null,
        left: null,
      },
      histories: [],
    };
  },
  components: { ContextMenu },
  methods: {
    clear() {
      this.position = {
        top: null,
        left: null,
      };
      this.textData = {
        index: null,
        offset: null,
        splitText: null,
      };
      this.dialog = false;
    },
    onMouseDown({ ctrlKey }) {
      this.isStartedMoving = !!ctrlKey;
    },
    onContextMenu(e) {
      this.isStartedMoving = true;
      this.$nextTick(() => {
        this.onMouseUp(e);
      });
    },
    getTextInInput(el) {
      if (
        el.tagName === "TEXTAREA" ||
        (el.tagName === "INPUT" && el.type === "text")
      ) {
        const { selectionStart, selectionEnd } = el;
        return {
          index: selectionStart,
          offset: selectionEnd,
        };
      } else {
        const { anchorOffset, focusOffset } = window.getSelection();
        return {
          index: anchorOffset,
          offset: focusOffset,
        };
      }
    },
    onMouseUp(e) {
      if (this.isStartedMoving) {
        const { clientX, clientY, target } = e;
        const { index, offset } = this.getTextInInput(target);
        const splitText = this.item.name.substring(index, offset);
        if (index !== 0 && offset !== 0 && this.item.name.length !== index) {
          this.textData = {
            index: index,
            offset: offset,
            splitText,
          };
          this.dialog = true;
          this.position = {
            top: clientY,
            left: clientX,
          };
        }
        this.isStartedMoving = false;
      }
    },
    remove() {
      const { index, offset } = this.textData;
      if (typeof index === "number" && typeof offset === "number") {
        const history = new HistoryText(
          historyTextType.deleted,
          this.item.name
        );
        this.item.name =
          this.item.name.substring(0, index) + this.item.name.substring(offset);
        this.histories.push(history);
      }
      this.clear();
    },
    split() {
      const { index, offset } = this.textData;
      if (typeof index === "number" && typeof offset === "number") {
        const splitText = this.item.name.substring(index, offset);
        const history = new HistoryText(
          historyTextType.split,
          this.item.name,
          splitText
        );
        this.item.name =
          this.item.name.substring(0, index) + this.item.name.substring(offset);
        this.histories.push(history);
        this.item._attrs.push(splitText);
      }
      this.clear();
    },
    clickDown() {
      if (this.histories.length && !this.dialog) {
        const history = this.histories.pop();
        this.item.name = history.text;
        if (history.splitText) {
          this.item_attrs.splice(this.item_attrs.indexOf(history.splitText), 1);
        }
      }
    },
    keyDown({ code, ctrlKey }) {
      if (code === "KeyZ" && ctrlKey) {
        if (this.histories.length && !this.dialog) {
          const history = this.histories.pop();
          this.item.name = history.text;
          if (history.splitText) {
            this.item_attrs.splice(
              this.item_attrs.indexOf(history.splitText),
              1
            );
          }
        }
      }
    },
  },
  watch: {
    constructorDialog(val) {
      if (!val) {
        this.item_attrs = [];
      }
    },
  },
  created() {
    document.addEventListener("keydown", this.keyDown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyDown);
  },
};
</script>
